import { axiosInstance } from "@/plugins/axios";

export interface ProductSpecificRuleExceptionPayload {
    offset: null,
    limit: null,
    id_product_specific_rule: null,
}

export async function getProductSpecificRuleExceptions(payload: ProductSpecificRuleExceptionPayload){
    let url = 'product_specific_rule_exceptions?';

    if (payload.limit) {
        url += `limit=${payload.limit}&offset=${payload.offset}&`;
    }

    if (payload.id_product_specific_rule) {
        url += `id_product_specific_rule=${payload.id_product_specific_rule}&`;
    }

    const response = await axiosInstance.get(url);
    return response.data;
}